import { Component, Inject, Input } from 'angular-ts-decorators';

import { ICompareCheckboxService } from '../services/compare-checkbox.service';

import template from './compare-checkbox.component.html';

interface ICompareCheckboxComponent {
  id?: number;
  text?: string;
  checked: boolean;
  message: string;
  toggle(): void;
}

const defaultMessage = 'Compare';

@Component({
  selector: 'compareCheckbox',
  template,
})
export class CompareCheckboxComponent implements ICompareCheckboxComponent {
  public static $inject: ReadonlyArray<string> = ['compareCheckboxService'];

  @Input() public id?: number;
  @Input('@?') public text?: string;

  constructor(@Inject('compareCheckboxService') private compareCheckboxService: ICompareCheckboxService) {
  }

  public get message(): string {
    return this.text ? this.text : defaultMessage;
  }

  public get checked(): boolean {
    return this.compareCheckboxService.isChecked(this.id);
  }

  public toggle(): void {
    return this.compareCheckboxService.toggle(this.id);
  }
}
